import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Stack from '@mui/material/Stack';
import PropTypes from 'prop-types';
import { FacetFactory } from '../FacetFactory';
import getFacetFromSlug from '../../../functions/getFacetFromSlug';
import getSearchValues from '../../../functions/getSearchValues';

const FacetSection = ({ searchParameters, section, facets, ...props }) => {

  if (!facets) {
    return null;
  }
  if (!section.search_show) {
    return null;
  }
  const displayValues = section.values.filter(({ search_show }) => search_show === true).filter(({ slug, type }) => {
    const facetData = getFacetFromSlug({ facets, slug });
    if (type === 'bool' && facetData && facetData > 0) {
      return true;
    }
    if ((type === 'int' || type === 'float') && facetData.minValue < facetData.maxValue) {
      return true;
    }

    if ((type === 'name' || type === 'names' || type === 'term' || type === 'stars') && (facetData?.length > 1 || slug === 'stock_availability')) {
      return true;
    }
    return false;
  });

  if (!displayValues.length) {
    return null;
  }
  const hasValues = displayValues.filter(({ slug, type }) => {
    const v = getSearchValues({ searchParameters, slug, type });
    if (type === 'bool' && v === true) {
      return true;
    }
    if ((type === 'int' || type === 'float') && (v?.min || v?.max)) {
      return true;
    }
    if ((type === 'name' || type === 'names' || type === 'term' || type === 'stars') && v?.length > 0) {
      return true;
    }
    return false;
  }).length > 0;

  const [expanded, setExpanded] = React.useState(section.search_open || hasValues);

  return (
    <Accordion
      disableGutters
      elevation={0} expanded={expanded} onChange={() => setExpanded(!expanded)}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Stack direction={'row'} spacing={2}>
          {section.icon && section.icon}
          <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>
            {section.name}
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails sx={{ pb: 0, pt: 0 }}>
        <Stack spacing={1}>
          {displayValues.map((v, i) => (
            <FacetFactory key={i} {...v} searchParameters={searchParameters} facets={facets} {...props} />
          ))}
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};
FacetSection.defaultProps = {
  searchParameters: {},
  onChange: () => {
  }
};
FacetSection.propTypes = {
  onChange: PropTypes.func.isRequired,
  searchParameters: PropTypes.shape({}).isRequired,
  facets: PropTypes.shape({}).isRequired,
  section: PropTypes.shape({
    'details_open': PropTypes.bool,
    'details_show': PropTypes.bool,
    'icon': PropTypes.node,
    'name': PropTypes.node.isRequired,
    'search_open': PropTypes.bool,
    'search_show': PropTypes.bool,
    'values': PropTypes.arrayOf(PropTypes.shape({
      'category': PropTypes.node,
      'details_show': PropTypes.bool,
      'name': PropTypes.node,
      'reverse': PropTypes.bool,
      'search_show': PropTypes.bool,
      'slug': PropTypes.string.isRequired,
      'type': PropTypes.string.isRequired
    }))
  }).isRequired
};
export default FacetSection;

export { FacetSection };